import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyleForgotPassword = makeStyles((theme) => createStyles({
    cardTitle: {
        fontWeight: "bold!important",
        color: "#888",
    }
}));